import { t } from "ttag";

import { ErrorState } from "@/app/components/legacy-components";
import { useUpcomingEvents } from "@/features/coaching/hooks";
import { Card, UserHeartRoundedIcon } from "@/shared/ui";
import { UpcomingEvents } from "./upcoming-events";

export const MyAgendaSection = () => {
  const { data: events, isError, isSuccess } = useUpcomingEvents();

  if (!events.length) {
    return null;
  }

  return (
    <Card.Root ghost>
      <Card.Header>
        <Card.Title icon={UserHeartRoundedIcon}>{t`My agenda`}</Card.Title>
      </Card.Header>

      {isError && (
        <ErrorState className="justify-self-center border-transparent" />
      )}

      {isSuccess && <UpcomingEvents events={events} />}
    </Card.Root>
  );
};
